import axios from "axios";

export function getCertificateList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Certificate/GetAllCertificates", config);
}

export function getCertificateById(id) {
  const config = {
    params: {
      id: id,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Certificate/GetCertificateById", config);
}

export function addCertificate(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Certificate/add", data);
}

export function updateCertificate(data) {
  return axios.put(process.env.VUE_APP_API_URL + "Certificate/update", data);
}

export function deleteCertificate(id) {
  const config = {
    params: {
      id: id,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Certificate/deleted", config);
}

//Upload Excel Certificate
export function uploadCertificate(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Certificate/uploadcertificate", data, config);
}
